import React from 'react';
import { FieldArray } from 'react-final-form-arrays';

import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';

import CheckboxItem from '../../CheckboxItem/CheckboxItem';

import './UsingWPSection.scss';
import { WpIcon } from 'Wpds/components/icon';

export default function UsingWPSection() {
  return (
    <FieldGroup label="What do you hope to use Perform for?" labelClassName="onboarding-form-label pt-3 mb-3">
      <FieldArray name="profile.usingWP">
        {({ fields }) => {
          return (
            <>
              {fields.map((name, index) => (
                <div key={name} className="d-flex align-items-center">
                  <CheckboxItem key={name} index={index} name={name} placeholder="Other" />
                  <div className="p-2 mb-2" style={{ width: '30px' }}>
                    {index > 2 && (
                      <div
                        className="cursor-pointer text-danger"
                        aria-hidden="true"
                        onClick={() => fields.remove(index)}
                      >
                        <WpIcon name="times" />
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <div className="d-flex align-items-center w-100">
                <div
                  className="using-wp-section-add px-2 py-1 mb-2 cursor-pointer d-flex align-items-center w-100"
                  onClick={() => fields.push({ label: '', editable: true })}
                >
                  <span className="mr-2">
                    <WpIcon name="plus-circle" />
                  </span>
                  Something else
                </div>
                <div className="p-2 mb-2" style={{ width: '30px' }} />
              </div>
            </>
          );
        }}
      </FieldArray>
    </FieldGroup>
  );
}
